/**
 * Date helpers for display and parsing.
 * ISO date: YYYY-MM-DD  →  display: DD/MM/YYYY
 */

const pad2 = (n) => String(n).padStart(2, '0');

/**
 * Formats a date value to DD/MM/YYYY.
 * Accepts: "1979-12-16", "1979-12-16T00:00:00", Date.
 */
export const formatDateToDisplay = (value) => {
  if (value == null || value === '') {
    return '';
  }

  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) {
      return '';
    }
    return `${pad2(value.getDate())}/${pad2(value.getMonth() + 1)}/${value.getFullYear()}`;
  }

  const raw = String(value).trim();
  const isoDateMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoDateMatch) {
    const [, year, month, day] = isoDateMatch;
    return `${day}/${month}/${year}`;
  }

  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) {
    return raw;
  }
  return `${pad2(parsed.getDate())}/${pad2(parsed.getMonth() + 1)}/${parsed.getFullYear()}`;
};

/**
 * Formats a datetime value to DD/MM/YYYY HH:mm.
 */
export const formatDateTimeToDisplay = (value) => {
  if (value == null || value === '') {
    return '';
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return formatDateToDisplay(value);
  }

  return `${formatDateToDisplay(date)} ${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
};

const dateHelper = {
  formatDateToDisplay,
  formatDateTimeToDisplay,
};

export default dateHelper;
